import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import "./MainPageSlider.scss";
import api from "../admin/api/api";
import { image_base_url } from "../admin/api/api";

function MainPageSlider() {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    loadSliders();
  }, []);

  const loadSliders = async () => {
    try {
      const res = await api.get("/slider/active"); // API
      setSliders(res.data);
    } catch (error) {
      console.error("Slider load error", error);
    }
  };


  return (
    <Carousel
      fade
      controls={false}
      indicators={true}
      interval={3000}
      pause={false}
      className="main-slider"
    >
      {sliders.map((slider) => (

        <Carousel.Item key={slider.sliderId}>

          <img
            className="d-block w-100 slider-img"
            src={image_base_url + slider.imageUrl}
            alt="slider"
          />

        </Carousel.Item>

      ))}
     
    </Carousel>
  );
}

export default MainPageSlider;